import React, { useEffect } from 'react';
import { Button, IconButton } from '@fiverr-private/button';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { Heading, Text } from '@fiverr-private/typography';
import { ArrowRightIcon, TimesIcon } from '@fiverr-private/visuals';
import { Image } from '@fiverr-private/media';
import { translate } from '@fiverr-private/i18n-react';
import { ComplianceBiEventsData } from '../../types/upgradeModal';
import {
    reportClickedExitWelcomeToAdvancedModal,
    reportClickedWelcomeToAdvancedContinue,
    reportWelcomeToAdvancedModalImpression,
} from '../../events';

const IMAGE_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/f85b5fd54c939b1e1c9fee5f5b11e6c0-1742818045993/Header%20Image%20Advanced.jpg';

export interface WelcomeToAdvancedStepProps {
    onNextStep: () => void;
    nextButtonText: string;
    onClose: () => void;
    biData: ComplianceBiEventsData;
}

export const WelcomeToAdvancedStep = ({ onNextStep, nextButtonText, onClose, biData }: WelcomeToAdvancedStepProps) => {
    useEffect(() => {
        reportWelcomeToAdvancedModalImpression(biData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNextStepClick = () => {
        onNextStep();
        reportClickedWelcomeToAdvancedContinue(biData);
    };

    const handleClose = () => {
        onClose();
        reportClickedExitWelcomeToAdvancedModal(biData);
    };

    return (
        <Container position="relative">
            <Stack position="absolute" right={1} paddingRight={'5'} paddingTop={'5'}>
                <IconButton onClick={handleClose} aria-label="close" variant="ghost">
                    <TimesIcon color="white" size="md" />
                </IconButton>
            </Stack>

            <Stack as="section" direction="column" flex="1" flexBasis="50%" maxWidth="100%">
                <Image alt="image" maxWidth="100%" src={IMAGE_URL} />
                <Stack padding="8" paddingBottom={'0'} paddingTop={'7'} direction={'column'}>
                    <Heading size={'h_md'}>{translate(`upsell.welcome_advance_modal.welcome`)}</Heading>
                    <Text>{translate(`upsell.welcome_advance_modal.body`)}</Text>
                </Stack>
                <Stack
                    width={'100%'}
                    direction={'row'}
                    justifyContent={'spaceBetween'}
                    paddingTop="5"
                    paddingBottom="8"
                    paddingRight="8"
                >
                    <Box
                        justifySelf={'flexEnd'}
                        width={'100%'}
                        direction={'row'}
                        display={'flex'}
                        justifyContent={'flexEnd'}
                        gap={'3'}
                    >
                        <Button onClick={handleNextStepClick}>
                            <Stack alignItems={'center'} gap={'1.5'}>
                                <Text size={'b_sm'} color={'white'} fontWeight={'semibold'}>
                                    {nextButtonText}
                                </Text>
                                <ArrowRightIcon size={'sm'} color={'white'} />
                            </Stack>
                        </Button>
                    </Box>
                </Stack>
            </Stack>
        </Container>
    );
};

export default WelcomeToAdvancedStep;
